import React from "react";
import { Translation } from "react-i18next";
import * as CONSTANTS from "../../utilities/Constants";
import { Button } from "@abb/abb-common-ux-react";
import AbbTableComponent from "../shared/AbbTableComponent";



interface IPropertyTableProps {
    list:any[];
    onChangeValue:any;
    onBlurValue:any;
    setPropertiesOrderNo:any;
    isNext:boolean;
    onNextClick:any;
}

export default class PropertyTable extends React.Component<IPropertyTableProps, {}> {
    private _mount: boolean = false;

    constructor(props: IPropertyTableProps) {
        super(props);
        this._mount = true;
    }

    componentWillUnmount() {
        this._mount = false;
    }

    componentDidMount() {
        this._mount = true;
    }

    public render() {
        return (
            <Translation>
                {(t) => (
                    <React.Fragment>
                        <div className=" w-100">
                            <AbbTableComponent
                                authKey={CONSTANTS.AUTHKEY_GRADE}
                                columns={[
                                    {
                                        dataField: "propertyName",
                                        text: t(CONSTANTS.MODULE_PROPERTY),
                                        editable: false,
                                        isFixed: true,
                                        headerStyle: (colum, colIndex) => {
                                            return { width: "35%", textAlign: "left" };
                                        },
                                    },
                                    {
                                        dataField: "propertyCustomId",
                                        text: t(CONSTANTS.LABLE_ID),
                                        editable: false,
                                        headerStyle: (colum, colIndex) => {
                                            return { width: "20%", textAlign: "left" };
                                        },
                                    },
                                    {
                                        dataField: "target",
                                        text: t(CONSTANTS.TARGET),
                                        isEditable: true,
                                        headerStyle: (colum, colIndex) => {
                                            return { width: "10%", textAlign: "left" };
                                        },
                                    },
                                    {
                                        dataField: "sigma",
                                        text: t(CONSTANTS.SIGMA),
                                        isEditable: true,
                                        headerStyle: (colum, colIndex) => {
                                            return { width: "10%", textAlign: "left" };
                                        },
                                    },
                                    {
                                        dataField: "sigmapercent",
                                        text: "",
                                        isEditable: true,
                                        headerStyle: (colum, colIndex) => {
                                            return { width: "10%", textAlign: "left" };
                                        },
                                    },
                                    {
                                        dataField: "minValue",
                                        text: t(
                                            CONSTANTS.LABLE_MIN +
                                            " " +
                                            CONSTANTS.LABEL_VALUE
                                        ),
                                        isEditable: true,
                                        headerStyle: (colum, colIndex) => {
                                            return { width: "10%", textAlign: "left" };
                                        },
                                    },
                                    {
                                        dataField: "maxValue",
                                        text: t(
                                            CONSTANTS.LABLE_MAX +
                                            " " +
                                            CONSTANTS.LABEL_VALUE
                                        ),
                                        isEditable: true,
                                        headerStyle: (colum, colIndex) => {
                                            return { width: "10%", textAlign: "left" };
                                        },
                                    },
                                    {
                                        dataField: "alarmLow1",
                                        text: t(CONSTANTS.ALARMLOWONE),
                                        isEditable: true,
                                        headerStyle: (colum, colIndex) => {
                                            return { width: "10%", textAlign: "left" };
                                        },
                                    },
                                    {
                                        dataField: "alarmHigh1",
                                        text: t(CONSTANTS.ALARMHIGHONE),
                                        isEditable: true,
                                        headerStyle: (colum, colIndex) => {
                                            return { width: "10%", textAlign: "left" };
                                        },
                                    },
                                    {
                                        dataField: "alarmLow2",
                                        text: t(CONSTANTS.ALARMLOWTWO),
                                        isEditable: true,
                                        headerStyle: (colum, colIndex) => {
                                            return { width: "10%", textAlign: "left" };
                                        },
                                    },
                                    {
                                        dataField: "alarmHigh2",
                                        text: t(CONSTANTS.ALARMHIGHTWO),
                                        isEditable: true,
                                        headerStyle: (colum, colIndex) => {
                                            return { width: "10%", textAlign: "left" };
                                        },
                                    },
                                    {
                                        dataField: "rejectLow",
                                        text: t(CONSTANTS.REJECTLOW),
                                        isEditable: true,
                                        headerStyle: (colum, colIndex) => {
                                            return { width: "10%", textAlign: "left" };
                                        },
                                    },
                                    {
                                        dataField: "rejectHigh",
                                        text: t(CONSTANTS.REJECTHIGH),
                                        isEditable: true,
                                        headerStyle: (colum, colIndex) => {
                                            return { width: "10%", textAlign: "left" };
                                        },
                                    },
                                    {
                                        dataField: "gain",
                                        text: t(CONSTANTS.GAIN),
                                        isEditable: true,
                                        headerStyle: (colum, colIndex) => {
                                            return { width: "10%", textAlign: "left" };
                                        },
                                    },
                                    {
                                        dataField: "offset",
                                        text: t(CONSTANTS.OFFSET),
                                        isEditable: true,
                                        headerStyle: (colum, colIndex) => {
                                            return { width: "10%", textAlign: "left" };
                                        },
                                    },
                                ]}
                                list={this.props.list}
                                select={false}
                                isFixedColumn={true}
                                isEditable={true}
                                delete={false}
                                cellEdit={this.props.onChangeValue}
                                cellBlurEdit={this.props.onBlurValue}
                                setPropertiesOrderNo={this.props.setPropertiesOrderNo}
                                form={true}
                                moduleName={t(CONSTANTS.MODULE_GRADE)}
                                name={
                                    t(CONSTANTS.MODULE_GRADE) +
                                    " " +
                                    CONSTANTS.MODULE_PROPERTY
                                }
                            />
                            <hr className="hr-line" />
                            <div className="float-right mt-2">
                                <Button
                                    type="primary-blue"
                                    disabled={this.props.isNext ? false : true}
                                    icon="abb/right"
                                    text={t(CONSTANTS.BUTTON_NEXT)}
                                    onClick={this.props.onNextClick}
                                />
                            </div>
                            <div className="clearfix" />
                        </div>
                    </React.Fragment>
                )
                }
            </Translation>
        );
    }
}
